import React from 'react';
import MainHeader from '../../../components/atoms/Typography/MainHeader';
import DivTdsBody01 from '../../../components/atoms/Typography/DivTdsBody01';

function MethodologyAbout() {
  return (
    <div>
      <MainHeader>About</MainHeader>
      <DivTdsBody01>
        Our ambition is to improve decision-making in businesses that are transforming to a
        sustainability-driven development methodology and to be a hub between business, climate
        science and software development. In order to do this we aim to continuously develop the
        calculation model. As knowledge and expertise in the topic grows, so will our calculations.
      </DivTdsBody01>
      <DivTdsBody01>
        The latest update to our calculation model includes more services and consider more aspects
        of your cloud server usage, such as storage, memory and network along with the embodied
        emissions.
      </DivTdsBody01>
    </div>
  );
}

export default MethodologyAbout;
